// extracted by mini-css-extract-plugin
export default {"Dot":"_Dot--k063A","Red":"_Red--z0kiC","Green":"_Green--eLT_r","Orange":"_Orange--loZZw"};